<template>
  <div class="common-poster-edit">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>海报分享模板</BreadcrumbItem>
          <BreadcrumbItem>编辑</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">编辑</div>
      </div>
    </div>
    <div class="header-switch">
      <Button type="primary" style="margin-right: 20px" @click="save()">保存</Button>
      <Button @click="exit()">退出</Button>
    </div>

    <div class="poster-edit-content">
      <div class="imgBox">
        <!-- <img :src="url"> -->
        <canvas id="sharePoster" class="canvas"></canvas>
      </div>
      <div class="popperBox">
        <popper :show-popper="visible" @close="visible = false" placement="right">
          <div slot="content" class="ctt1-poptip">
            <Form ref="formValidate" :label-width="100">
              <FormItem label="更换背景图：">
                <div class="my-upload">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList"
                    :key="'upload' + index"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width: 100px; height: 100px" />
                      <div class="my-upload-list-cover">
                        <Icon
                          type="ios-eye-outline"
                          @click.native="handleView(item.url)"
                        ></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemove(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px; height: 100px">
                        <Icon
                          type="ios-loading"
                          size="20"
                          class="demo-spin-icon-load"
                        ></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    multiple
                    type="drag"
                    :action="uploadUrl"
                    style="display: inline-block"
                    v-show="uploadList && uploadList.length < 1"
                  >
                    <div
                      style="
                        width: 100px;
                        height: 100px;
                        padding-top: 18px;
                        color: rgb(133, 133, 133);
                      "
                    >
                      <div style="font-size: 25px">
                        +
                        <p style="font-size: 14px">上传图片</p>
                      </div>
                    </div>
                  </Upload>
                  <iModal title="图片查看" cancel-text v-model="visibleImg">
                    <div style="text-align: center">
                      <img :src="imgName" v-if="visibleImg" style="max-width: 100%" />
                    </div>
                  </iModal>
                </div>
                <p class="upload-p" style="display: block; font-size: 12px">
                  （图片要求：2M以下的jpg或png格式，尺寸：750×1100px）
                </p>
              </FormItem>
            </Form>
          </div>
        </popper>
      </div>
    </div>
    <img id="bgImg" style="display: none" src="@/assets/img/empty.png" />
    <img id="bgImg2" style="display: none" src="@/assets/img/qrCode.jpg" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import popper from "@components/vue-popper/VuePopper.vue";

export default {
  name: "host-common-posterEdit",
  data() {
    return {
      visible: true,
      url: "",
      uploadList: [],
      defaultList: [],
      imgName: "",
      visibleImg: false,
      editId: "",
      posterInfo: {},
      CompanyName: {},
      Logo: {},
      BoothCode: {},
      SunCode: {},
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
    }),
  },
  methods: {
    ...mapActions({
      getSharePosterDetail: "hostCommonModule/getSharePosterDetail",
      editSharePoster: "hostCommonModule/editSharePoster",
    }),
    async init() {
      let query = this.$route.query;
      this.editId = query.id;
      let data = await this.getSharePosterDetail(this.editId);
      if (data && data.posterInfo) {
        data.posterInfo = JSON.parse(data.posterInfo);
      }

        this.posterInfo = data;
    //   this.posterInfo = {
    //     exhibitionId: "601156ff-abf5-439f-83df-8e5f9ef180f2",
    //     posterId: "98606694-f423-4ea4-a0d5-5e71c7b45643",
    //     posterInfo: {
    //       Name: "默认模板3",
    //       Height: 550,
    //       Width: 375,
    //       Content: [
    //         {
    //           Key: "CompanyName",
    //           X: 88,
    //           Y: 72,
    //           Height: 18,
    //           Width: 270,
    //           FontFamily: "sans-serif",
    //           FontSize: 16,
    //           FontStyle: "normal",
    //           FontWeight: "bold",
    //           TextAlign: "left",
    //           Color: "#5a5959",
    //         },
    //         {
    //           Key: "BoothCode",
    //           X: 88,
    //           Y: 113,
    //           Height: 18,
    //           Width: 270,
    //           FontFamily: "sans-serif",
    //           FontSize: 18,
    //           FontStyle: "normal",
    //           FontWeight: "bold",
    //           TextAlign: "left",
    //           Color: "#5a5959",
    //         },
    //         {
    //           Key: "SunCode",
    //           X: 65,
    //           Y: 405,
    //           Height: 80,
    //           Width: 80,
    //           FontFamily: null,
    //           FontSize: 0,
    //           FontStyle: null,
    //           FontWeight: null,
    //           TextAlign: null,
    //           Color: null,
    //         },
    //       ],
    //     },
    //    backgroundImage: "https://oss.cmef.com.cn/cloudExhibition/imgs/202409/fbdb0bcd8ddc4bb5b5b0fe83cf8a6bea.png",
    //     isShow: true,
    //     isDeleted: false,
    //     inTime: "2021-09-01T16:18:04.543",
    //     inDate: "2021-09-01T00:00:00",
    //     upTime: "2021-09-01T16:18:04.543",
    //     id: "d073b074-df44-4f26-8280-0c235e34e983",
    //   };

      if (this.posterInfo.backgroundImage) {
        this.url = this.posterInfo.backgroundImage;
        this.initCanvas();
        this.uploadList = [
          {
            status: "finished",
            showProgress: false,
            url: this.posterInfo.backgroundImage,
          },
        ];
      }
      console.log("详情：", this.posterInfo);
    },
    initCanvas() {
      this.posterInfo.posterInfo.Content.map((c) => {
        // if (c.Key === "CompanyName") {
        //   this.CompanyName = c;
        // }
        // if (c.Key === "Logo") {
        //   this.Logo = c;
        // }
        if (c.Key == "BoothCode") {
          this.BoothCode = c;
        }
        if (c.Key == "SunCode") {
          this.SunCode = c;
        }
      });
      let canvas = document.getElementById("sharePoster");
      // 画板宽、高
      canvas.width = this.posterInfo.posterInfo.Width;
      canvas.height = this.posterInfo.posterInfo.Height;
      let ctx = canvas.getContext("2d");
      // 背景图
      let img = new Image();
      img.src = this.url;
      // img加载完后绘制背景图，否则会出现刷新后可能不显示的bug
      const that = this;
      img.onload = function () {
        ctx.drawImage(
          img,
          0,
          0,
          that.posterInfo.posterInfo.Width,
          that.posterInfo.posterInfo.Height
        );
        that.posterInfo.posterInfo.Content.map((c) => {
          if (c.Key === "CompanyName") {
            ctx.font =
              c.FontStyle + " " + c.FontWeight + " " + c.FontSize + "px " + c.FontFamily;
            ctx.fillStyle = c.Color;
            ctx.textAlign = c.TextAlign;
            if (c.TextAlign === "center") {
              ctx.fillText(
                "公司名称",
                that.posterInfo.posterInfo.Width / 2,
                c.Y + c.FontSize
              );
            } else {
              ctx.fillText("公司名称", c.X, c.Y + c.FontSize);
            }
          }
          if (c.Key === "Logo") {
            let bgImg = document.getElementById("bgImg");
            ctx.beginPath();
            ctx.arc(c.X + c.Width / 2, c.Y + c.Height / 2, c.Width / 2, 0, 2 * Math.PI);
            ctx.clip();
            ctx.drawImage(bgImg, c.X, c.Y, c.Width, c.Height);
          }
          // 展位号
          ctx.font =
            that.BoothCode.FontStyle +
            " " +
            that.BoothCode.FontWeight +
            " " +
            that.BoothCode.FontSize +
            "px " +
            that.BoothCode.FontFamily;
          ctx.textAlign = that.BoothCode.TextAlign;
          if (that.BoothCode.TextAlign === "center") {
            ctx.fillText(
              "展位号",
              that.posterInfo.posterInfo.Width / 2,
              that.BoothCode.Y + that.BoothCode.FontSize
            );
          } else {
            ctx.fillText(
              "展位号",
              that.BoothCode.X,
              that.BoothCode.Y + that.BoothCode.FontSize
            );
          }
          // 二维码
          ctx.save();
          let bgImg2 = document.getElementById("bgImg2");
          // ctx.beginPath();
          // ctx.arc(that.SunCode.X+that.SunCode.Width/2, that.SunCode.Y+that.SunCode.Height/2, that.SunCode.Width/2, 0, 2*Math.PI);
          // ctx.clip();
          ctx.drawImage(
            bgImg2,
            that.SunCode.X,
            that.SunCode.Y,
            that.SunCode.Width,
            that.SunCode.Height
          );
        });
      };
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visibleImg = true;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        this.url = file.url;
        this.initCanvas();
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    exit() {
      this.$router.go(-1);
    },
    async save() {
      if (this.uploadList.length < 1) {
        this.$Message.warning(`请上传背景图`);
        return;
      }
      let url = this.uploadList[0].url;
      let  PosterInfo= {"Name":"默认模板3","Height":550,"Width":375,"Content":[{"Key":"CompanyName","X":88,"Y":73,"Height":18,"Width":270,"FontFamily":"sans-serif","FontSize":16,"FontStyle":"normal","FontWeight":"bold","TextAlign":"left","Color":"#5a5959"},{"Key":"BoothCode","X":88,"Y":115,"Height":18,"Width":270,"FontFamily":"sans-serif","FontSize":16,"FontStyle":"normal","FontWeight":"bold","TextAlign":"left","Color":"#5a5959"},{"Key":"SunCode","X":65,"Y":405,"Height":80,"Width":80,"FontFamily":null,"FontSize":0,"FontStyle":null,"FontWeight":null,"TextAlign":null,"Color":null}]};

      let req = {
        Id: this.editId,
        SetValues: {
          BackgroundImage: url,
            //   PosterInfo: JSON.stringify(PosterInfo)
           },
      };
      let bool = await this.editSharePoster(req);
      if (bool && bool.successed) {
        this.$Message.success(`保存成功`);
        this.$router.push(`/host/index/common/common-poster`);
      } else {
        this.$Message.error(`保存失败，请重试`);
      }
    },
  },
  created() {
    this.init();
  },
  // mounted() {
  //   this.init();
  // },
  components: {
    popper,
  },
};
</script>

<style lang="scss" scoped>
.common-poster-edit {
  .header-switch {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
  .poster-edit-content {
    width: 800px;
    margin: 50px auto;
    display: flex;
    .imgBox {
      width: 377px;
      height: 626px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .popperBox {
      margin: 145px 40px 0 0;
      .ctt1-poptip {
        width: 540px;
        height: 288px;
        padding: 60px;
      }
    }
  }
}
</style>
